import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.mentores;

export const mentorService = {
  // Obtener mentores activos para dropdowns (no requiere permiso CRUD Mentores)
  async getMentoresActivos() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/mentores/activos`);
      return response;
    } catch (error) {
      console.error('Error al obtener mentores activos:', error);
      throw error;
    }
  },

  // Obtener todos los mentores
  async getAllMentores(page = null, pageSize = null) {
    try {
      let url = `${API_BASE_URL}/api/mentores`;
      const params = [];
      if (page) params.push(`page=${page}`);
      if (pageSize) params.push(`pageSize=${pageSize}`);
      if (params.length) url += `?${params.join('&')}`;
      // Return the full axios response so callers can handle paginated and non-paginated shapes
      return axios.get(url);
    } catch (error) {
      console.error('Error al obtener mentores:', error);
      throw error;
    }
  },

  // Obtener un mentor por ID
  async getMentorById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/mentores/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener mentor:', error);
      throw error;
    }
  },

  // Registrar un nuevo mentor
  async registrarMentor(mentorData) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/mentores/registrar`, mentorData);
      return response.data;
    } catch (error) {
      console.error('Error al registrar mentor:', error);
      throw error;
    }
  },

  // Actualizar un mentor
  async actualizarMentor(id, mentorData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/mentores/${id}`, mentorData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar mentor:', error);
      throw error;
    }
  },

  // Eliminar (inactivar) un mentor
  async eliminarMentor(id) {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/mentores/${id}/eliminar`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar mentor:', error);
      throw error;
    }
  }
};

export default mentorService;
